import React, { Component } from 'react'
import styled from 'styled-components'

const PrintTextStyle = styled.div`
  p {
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
  }
  span {
    font-family: monospace;
    line-height: 1.2;
    font-size: 16px;
    color: rgb(84, 84, 84);    
  }
`

class PrintText extends Component {
    constructor(props) {
        super(props)
        this.state = {
          lines: props ? props.text.trim().split("\n") : []
        }
    }

    render() {
        return (
            <PrintTextStyle> 
                <p>
                {this.state.lines.map((element,i) => {
                   return <span key={i}>
                        {i>0 ? (<br/>): null}
                        {element}
                    </span>
                })}
                </p>                       
            </PrintTextStyle>
        )
    }
}

export default PrintText